import { render } from "./Physical.vue?vue&type=template&id=2d1f49d2&scoped=true"
import script from "./Physical.vue?vue&type=script&lang=js"
export * from "./Physical.vue?vue&type=script&lang=js"

import "./Physical.vue?vue&type=style&index=0&id=2d1f49d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1f49d2"]])

export default __exports__